import HttpHelper from "../../utils/http-helper";
import HtmlHelper from "../../utils/html-helper";

class Main {
	constructor() {
        this.metaDescription = document.getElementById('meta-description');
        this.infoText = document.querySelector('#info-text');
        this.infoTextTemplate = '';
        this.module = 'expertise';

    }

	async run() {
        if (!!this.metaDescription) {
            document.title = 'Mustergutachten - anabin: Infoportal zu ausländischen Bildungsabschlüssen';
        }
        this.initializeModules();
        this.infoTextTemplate = await this.getInfo(this.module);
        this.infoText.innerHTML = null;
        this.infoText.appendChild(this.infoTextTemplate);
    }

	initializeModules() {
	}

    async getInfo(module) {
        const response = await HttpHelper.fetchData(`${location.origin}/api/public/infos/${module}`);
        return HtmlHelper.createElementFromHTML(`<div>${response?.data?.infoText}</div>` ?? '');
    }
}
const main = new Main();
main.run();
